//检测权限
class CheckAuth {
    //检测按钮是否有权限
    CheckButton(tag: string) {
        var authlist = JSON.parse(localStorage.getItem("userAuth"));
        if (authlist.length <= 0)
            return false;
        var result = authlist.filter((ele) => {
            return ele.value == tag;
        })
        if (result.length > 0)
            return true;
        else
            return false;
    }
}
const checkAuth = new CheckAuth();
export default checkAuth;